import {
  TCreateCompanySpecificBusinessClassificationReqDto,
  TCreateCompanySpecificBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/create-company-business-classification.dto";
import {
  TCreateCompanySpecificIndustryReqDto,
  TCreateCompanySpecificIndustryResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/create-company-specific-industry.dto";
import {
  TCreateMasterOccupationReqDto,
  TCreateMasterOccupationResDto,
} from "@/api/services/global/master/dtos/occupation/create-master-occupation.dto";
import { TGetMasterOccupationTreeResDto } from "@/api/services/global/master/dtos/occupation/get-master-occupation-tree.dto";
import {
  TSetHiddenMasterOccupationReqDto,
  TSetHiddenMasterOccupationResDto,
} from "@/api/services/global/master/dtos/occupation/set-hidden-master-occupation.dto";
import {
  TReorderMasterOccupationsReqDto,
  TReorderMasterOccupationsResDto,
} from "@/api/services/global/master/dtos/occupation/reorder-master-occupations.dto";
import {
  TUpdateMasterOccupationReqDto,
  TUpdateMasterOccupationResDto,
} from "@/api/services/global/master/dtos/occupation/update-master-occupation.dto";
import { TGetCompanySpecificIndustryListResDto } from "@/api/services/global/master/dtos/companySpecificIndustry/get-master-company-specific-industry-list.dto";
import {
  TCreateCompanyMainSkillReqDto,
  TCreateCompanyMainSkillResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/create-company-main-skill.dto";
import {
  TUpdateCompanyMainSkillReqDto,
  TUpdateCompanyMainSkillResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/update-company-main-skill.dto";
import {
  TUpdateCompanySpecificBusinessClassificationReqDto,
  TUpdateCompanySpecificBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/update-company-business-classification.dto";
import {
  TUpdateCompanySpecificIndustryReqDto,
  TUpdateCompanySpecificIndustryResDto,
} from "@/api/services/global/master/dtos/companySpecificIndustry/update-company-specific-industry.dto";
import {
  TCreateCareerCertificationReqDto,
  TCreateCareerCertificationResDto,
} from "@/api/services/global/master/dtos/create-career-certification.dto";
import { TCreateLanguageTestReqDto, TCreateLanguageTestResDto } from "@/api/services/global/master/dtos/create-language-test.dto";
import { TCreateLivingRelationshipReqDto, TCreateLivingRelationshipResDto } from "@/api/services/global/master/dtos/create-living-relationship.dto";
import {
  TCreateLocalGovernmentCounterReqDto,
  TCreateLocalGovernmentCounterResDto,
} from "@/api/services/global/master/dtos/create-local-government-counter.dto";
import { TCreateMainIndustryReqDto, TCreateMainIndustryResDto } from "@/api/services/global/master/dtos/create-main-industry.dto";
import { TCreateMainOccupationReqDto, TCreateMainOccupationResDto } from "@/api/services/global/master/dtos/create-main-occupation.dto";

import { TCreateSkillTestReqDto, TCreateSkillTestResDto } from "@/api/services/global/master/dtos/create-skill-test.dto";
import { TCreateSupportLanguageReqDto, TCreateSupportLanguageResDto } from "@/api/services/global/master/dtos/create-support-language.dto";
import { TGetCareerCertificationListResDto } from "@/api/services/global/master/dtos/get-master-career-certification-list.dto";
import { TGetLanguageTestListResDto } from "@/api/services/global/master/dtos/get-master-language-test-list.dto";
import { TGetMasterListResDto } from "@/api/services/global/master/dtos/get-master-list.dto";
import { TGetLivingRelationshipListResDto } from "@/api/services/global/master/dtos/get-master-living-relationship-list.dto";
import { TGetLocalGovernmentCounterListResDto } from "@/api/services/global/master/dtos/get-master-local-government-counter-list.dto";
import { TGetMainIndustryListResDto } from "@/api/services/global/master/dtos/get-master-main-industry-list.dto";
import { TGetMainOccupationListResDto } from "@/api/services/global/master/dtos/get-master-main-occupation-list.dto";
import {
  TCreateSpecificActivityOccupationReqDto,
  TCreateSpecificActivityOccupationResDto,
} from "@/api/services/global/master/dtos/create-specific-activity-occupation.dto";
import { TGetSpecificActivityOccupationListResDto } from "@/api/services/global/master/dtos/get-master-specific-activity-occupation-list.dto";
import {
  TUpdateSpecificActivityOccupationReqDto,
  TUpdateSpecificActivityOccupationResDto,
} from "@/api/services/global/master/dtos/update-specific-activity-occupation.dto";
import { TGetSkillTestListResDto } from "@/api/services/global/master/dtos/get-master-skill-test-list.dto";
import { TGetSupportLanguageListResDto } from "@/api/services/global/master/dtos/get-master-support-language-list.dto";
import { TCreateJobTypeReqDto, TCreateJobTypeResDto } from "@/api/services/global/master/dtos/jobType/create-job-type.dto";
import { TCreateMajorReqDto, TCreateMajorResDto } from "@/api/services/global/master/dtos/jobType/create-major.dto";
import { TGetMajorListResDto } from "@/api/services/global/master/dtos/jobType/get-master-major-list.dto";
import { TUpdateJobTypeReqDto, TUpdateJobTypeResDto } from "@/api/services/global/master/dtos/jobType/update-job-type.dto";
import { TUpdateMajorReqDto, TUpdateMajorResDto } from "@/api/services/global/master/dtos/jobType/update-major.dto";
import { TCreateNationalityReqDto, TCreateNationalityResDto } from "@/api/services/global/master/dtos/nationality/create-nationality.dto";
import { TGetNationalityListResDto } from "@/api/services/global/master/dtos/nationality/get-master-nationality-list.dto";
import { TGetRegionListResDto } from "@/api/services/global/master/dtos/nationality/get-master-region-list.dto";
import { TUpdateNationalityReqDto, TUpdateNationalityResDto } from "@/api/services/global/master/dtos/nationality/update-nationality.dto";
import {
  TUpdateOrderNationalityListReqDto,
  TUpdateOrderNationalityListResDto,
} from "@/api/services/global/master/dtos/nationality/update-order-nationality-list.dto";
import {
  TCreateResidencePeriodReqDto,
  TCreateResidencePeriodResDto,
} from "@/api/services/global/master/dtos/residencePeriod/create-residence-period.dto";
import {
  TCreateResidenceStatusReqDto,
  TCreateResidenceStatusResDto,
} from "@/api/services/global/master/dtos/residencePeriod/create-residence-status.dto";
import { TGetResidenceStatusListResDto } from "@/api/services/global/master/dtos/residencePeriod/get-master-residence-status-list.dto";
import {
  TUpdateResidencePeriodReqDto,
  TUpdateResidencePeriodResDto,
} from "@/api/services/global/master/dtos/residencePeriod/update-residence-period.dto";
import {
  TUpdateResidenceStatusReqDto,
  TUpdateResidenceStatusResDto,
} from "@/api/services/global/master/dtos/residencePeriod/update-residence-status.dto";
import {
  TCreateBusinessClassificationReqDto,
  TCreateBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/specificIndustry/create-business-classification.dto";
import {
  TCreateSpecificIndustryReqDto,
  TCreateSpecificIndustryResDto,
} from "@/api/services/global/master/dtos/specificIndustry/create-specific-industry.dto";
import { TGetSpecificIndustryListResDto } from "@/api/services/global/master/dtos/specificIndustry/get-master-specific-industry-list.dto";
import {
  TUpdateBusinessClassificationReqDto,
  TUpdateBusinessClassificationResDto,
} from "@/api/services/global/master/dtos/specificIndustry/update-business-classification.dto";
import {
  TUpdateSpecificIndustryReqDto,
  TUpdateSpecificIndustryResDto,
} from "@/api/services/global/master/dtos/specificIndustry/update-specific-industry.dto";
import {
  TUpdateCareerCertificationReqDto,
  TUpdateCareerCertificationResDto,
} from "@/api/services/global/master/dtos/update-career-certification.dto";

import { TUpdateLanguageTestReqDto, TUpdateLanguageTestResDto } from "@/api/services/global/master/dtos/update-language-test.dto";
import { TSyncLanguageTestLevelsReqDto, TSyncLanguageTestLevelsResDto } from "@/api/services/global/master/dtos/sync-language-test-levels.dto";
import { TCheckLanguageTestLevelInUseResDto } from "@/api/services/global/master/dtos/check-language-test-level-in-use.dto";
import { TUpdateLivingRelationshipReqDto, TUpdateLivingRelationshipResDto } from "@/api/services/global/master/dtos/update-living-relationship.dto";
import {
  TUpdateLocalGovernmentCounterReqDto,
  TUpdateLocalGovernmentCounterResDto,
} from "@/api/services/global/master/dtos/update-local-government-counter.dto";
import { TUpdateMainIndustryReqDto, TUpdateMainIndustryResDto } from "@/api/services/global/master/dtos/update-main-industry.dto";
import { TUpdateMainOccupationReqDto, TUpdateMainOccupationResDto } from "@/api/services/global/master/dtos/update-main-occupation.dto";
import { TUpdateSkillTestReqDto, TUpdateSkillTestResDto } from "@/api/services/global/master/dtos/update-skill-test.dto";
import { TUpdateSupportLanguageReqDto, TUpdateSupportLanguageResDto } from "@/api/services/global/master/dtos/update-support-language.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { globalApi } from "@/utils/api";
import { toNumber } from "@/utils/number";
import {
  TCreateStandardIndustryClassificationReqDto,
  TCreateStandardIndustryClassificationResDto,
  TGetStandardIndustryClassificationListReqDto,
  TGetStandardIndustryClassificationListResDto,
  TGetStandardIndustryClassificationResDto,
  TSetHiddenStandardIndustryClassificationReqDto,
  TUpdateStandardIndustryClassificationReqDto,
  TUpdateStandardIndustryClassificationResDto,
} from "@/api/services/global/master/dtos/standard-industry/standard-industry-classification.dto";
import {
  TGetStandardIndustryGroupListReqDto,
  TGetStandardIndustryGroupListResDto,
  TCreateStandardIndustryGroupReqDto,
  TCreateStandardIndustryGroupResDto,
  TUpdateStandardIndustryGroupReqDto,
  TUpdateStandardIndustryGroupResDto,
} from "@/api/services/global/master/dtos/standard-industry/standard-industry-group.dto";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";

//get-master-list
export const fetchMasterListApi = async (): Promise<TGetMasterListResDto> => {
  const rs = await globalApi.get<TGetMasterListResDto>(`/master`);
  return rs.data;
};

export const useGetMasterDataList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_DATA],
    queryFn: () => fetchMasterListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//nationalities
export const fetchNationalityListApi = async (): Promise<TGetNationalityListResDto> => {
  const rs = await globalApi.get<TGetNationalityListResDto>(`/master/regions/nationalities`);
  return rs.data;
};

export const fetchRegionListApi = async (): Promise<TGetRegionListResDto> => {
  const rs = await globalApi.get<TGetRegionListResDto>(`/master/regions`);
  return rs.data;
};

export const createNationalityApi = async (payload: TCreateNationalityReqDto): Promise<TCreateNationalityResDto> => {
  const rs = await globalApi.post<TCreateNationalityResDto>(`/master/regions/${payload.regionId}/nationalities`, payload);
  return rs.data;
};

export const updateNationalityApi = async (nationalityId: number, payload: TUpdateNationalityReqDto): Promise<TUpdateNationalityResDto> => {
  const rs = await globalApi.put<TUpdateNationalityResDto>(`/master/regions/${payload.regionId}/nationalities/${nationalityId}`, payload);
  return rs.data;
};

export const updateOrderNationalityListApi = async (payload: TUpdateOrderNationalityListReqDto): Promise<TUpdateOrderNationalityListResDto> => {
  const rs = await globalApi.put<TUpdateOrderNationalityListResDto>(`/master/regions/nationalities/order`, payload);
  return rs.data;
};

export const setHiddenNationalityApi = async (
  regionId: number,
  nationalityId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateNationalityResDto> => {
  const rs = await globalApi.put<TUpdateNationalityResDto>(`/master/regions/${regionId}/nationalities/${nationalityId}/set-hidden`, payload);
  return rs.data;
};

export const useGetNationalityList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_NATIONALITY],
    queryFn: () => fetchNationalityListApi(),
  });

  const nationalityOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.nationalityName, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], nationalityOptions, ...rest };
};

export const useGetRegionList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_REGION],
    queryFn: () => fetchRegionListApi(),
  });

  const nationalityOptions = useMemo(
    () =>
      data
        ? data.data.flatMap((item) => item.nationalities).map((item) => ({ label: item.nationalityName, value: item.id, hidden: item.isHidden }))
        : [],
    [data],
  );

  const regionOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.regionName, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], nationalityOptions, regionOptions, ...rest };
};

//job-types
export const fetchMajorListApi = async (): Promise<TGetMajorListResDto> => {
  const rs = await globalApi.get<TGetMajorListResDto>(`/master/majors`);
  return rs.data;
};

export const createMajorApi = async (payload: TCreateMajorReqDto): Promise<TCreateMajorResDto> => {
  const rs = await globalApi.post<TCreateMajorResDto>("/master/majors", payload);
  return rs.data;
};

export const createJobTypeApi = async (payload: TCreateJobTypeReqDto): Promise<TCreateJobTypeResDto> => {
  const rs = await globalApi.post<TCreateJobTypeResDto>(`/master/majors/${payload.majorId}/job-types`, payload);
  return rs.data;
};

export const updateJobTypeApi = async (jobTypeId: number, payload: TUpdateJobTypeReqDto): Promise<TUpdateJobTypeResDto> => {
  const rs = await globalApi.put<TUpdateJobTypeResDto>(`/master/majors/${payload.majorId}/job-types/${jobTypeId}`, payload);
  return rs.data;
};
export const setHiddenJobTypeApi = async (majorId: number, jobTypeId: number, payload: { isHidden: boolean }): Promise<TUpdateJobTypeResDto> => {
  const rs = await globalApi.put<TUpdateJobTypeResDto>(`/master/majors/${majorId}/job-types/${jobTypeId}/set-hidden`, payload);
  return rs.data;
};

export const updateMajorApi = async (payload: TUpdateMajorReqDto): Promise<TUpdateMajorResDto> => {
  const rs = await globalApi.put<TUpdateMajorResDto>("/master/majors", payload);
  return rs.data;
};

export const setHiddenMajorApi = async (majorId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/majors/${majorId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMajorList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_MAJOR],
    queryFn: () => fetchMajorListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//residence-periods
export const fetchResidenceStatusListApi = async (): Promise<TGetResidenceStatusListResDto> => {
  const rs = await globalApi.get<TGetResidenceStatusListResDto>(`/master/residence-statuses`);
  return rs.data;
};

export const createResidenceStatusApi = async (payload: TCreateResidenceStatusReqDto): Promise<TCreateResidenceStatusResDto> => {
  const rs = await globalApi.post<TCreateResidenceStatusResDto>("/master/residence-statuses", payload);
  return rs.data;
};

export const createResidencePeriodApi = async (payload: TCreateResidencePeriodReqDto): Promise<TCreateResidencePeriodResDto> => {
  const rs = await globalApi.post<TCreateResidencePeriodResDto>(`/master/residence-statuses/${payload.residenceStatusId}/residence-periods`, payload);
  return rs.data;
};

export const updateResidencePeriodApi = async (
  residencePeriodId: number,
  payload: TUpdateResidencePeriodReqDto,
): Promise<TUpdateResidencePeriodResDto> => {
  const rs = await globalApi.put<TUpdateResidencePeriodResDto>(
    `/master/residence-statuses/${payload.residenceStatusId}/residence-periods/${residencePeriodId}`,
    payload,
  );
  return rs.data;
};

export const setHiddenResidencePeriodApi = async (
  residenceStatusId: number,
  residencePeriodId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateResidencePeriodResDto> => {
  const rs = await globalApi.put<TUpdateResidencePeriodResDto>(
    `/master/residence-statuses/${residenceStatusId}/residence-periods/${residencePeriodId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const updateResidenceStatusApi = async (payload: TUpdateResidenceStatusReqDto): Promise<TUpdateResidenceStatusResDto> => {
  const rs = await globalApi.put<TUpdateResidenceStatusResDto>("/master/residence-statuses", payload);
  return rs.data;
};

export const setHiddenResidenceStatusApi = async (residenceStatusId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/residence-statuses/${residenceStatusId}/set-hidden`, payload);
  return rs.data;
};

export const useGetResidenceStatusList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_RESIDENCE_STATUS],
    queryFn: () => fetchResidenceStatusListApi(),
  });

  const residenceStatusOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.residenceStatus, value: item.id, hidden: item.isHidden })) : []),
    [data],
  );

  return { data: data?.data ?? [], residenceStatusOptions, ...rest };
};

//regular-renew-visa-specified-industry
export const fetchSpecificIndustryListApi = async (): Promise<TGetSpecificIndustryListResDto> => {
  const rs = await globalApi.get<TGetSpecificIndustryListResDto>(`/master/specific-industries`);
  return rs.data;
};

export const createSpecificIndustryApi = async (payload: TCreateSpecificIndustryReqDto): Promise<TCreateSpecificIndustryResDto> => {
  const rs = await globalApi.post<TCreateSpecificIndustryResDto>("/master/specific-industries", payload);
  return rs.data;
};

export const createBusinessClassificationApi = async (payload: TCreateBusinessClassificationReqDto): Promise<TCreateBusinessClassificationResDto> => {
  const rs = await globalApi.post<TCreateBusinessClassificationResDto>(
    `/master/specific-industries/${payload.specificIndustryId}/specific-business-classifications`,
    payload,
  );
  return rs.data;
};

export const updateBusinessClassificationApi = async (
  businessClassificationId: number,
  payload: TUpdateBusinessClassificationReqDto,
): Promise<TUpdateBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateBusinessClassificationResDto>(
    `/master/specific-industries/${payload.specificIndustryId}/specific-business-classifications/${businessClassificationId}`,
    payload,
  );
  return rs.data;
};

export const setHiddenBusinessClassificationApi = async (
  specificIndustryId: number,
  businessClassificationId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateBusinessClassificationResDto>(
    `/master/specific-industries/${specificIndustryId}/specific-business-classifications/${businessClassificationId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const updateSpecificIndustryApi = async (payload: TUpdateSpecificIndustryReqDto): Promise<TUpdateSpecificIndustryResDto> => {
  const rs = await globalApi.put<TUpdateSpecificIndustryResDto>("/master/specific-industries", payload);
  return rs.data;
};

export const updateSpecificIndustryOrderApi = async (payload: TUpdateSpecificIndustryReqDto): Promise<TUpdateSpecificIndustryResDto> => {
  const rs = await globalApi.put<TUpdateSpecificIndustryResDto>("/master/specific-industries/order", payload);
  return rs.data;
};

export const setHiddenSpecificIndustryApi = async (specificIndustryId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/specific-industries/${specificIndustryId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSpecificIndustryList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_INDUSTRY],
    queryFn: () => fetchSpecificIndustryListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//living-relationship
export const fetchLivingRelationshipListApi = async (): Promise<TGetLivingRelationshipListResDto> => {
  const rs = await globalApi.get<TGetLivingRelationshipListResDto>("/master/living-relationships");
  return rs.data;
};

export const createLivingRelationshipApi = async (payload: TCreateLivingRelationshipReqDto): Promise<TCreateLivingRelationshipResDto> => {
  const rs = await globalApi.post<TCreateLivingRelationshipResDto>("/master/living-relationships", payload);
  return rs.data;
};

export const updateLivingRelationshipApi = async (payload: TUpdateLivingRelationshipReqDto): Promise<TUpdateLivingRelationshipResDto> => {
  const rs = await globalApi.put<TUpdateLivingRelationshipResDto>("/master/living-relationships", payload);
  return rs.data;
};

export const setHiddenLivingRelationshipApi = async (livingRelationshipId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/living-relationships/${livingRelationshipId}/set-hidden`, payload);
  return rs.data;
};

export const useGetLivingRelationshipList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_LIVING_RELATIONSHIP],
    queryFn: () => fetchLivingRelationshipListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//main-occupation
export const fetchMainOccupationListApi = async (): Promise<TGetMainOccupationListResDto> => {
  const rs = await globalApi.get<TGetMainOccupationListResDto>("/master/main-occupations");
  return rs.data;
};

export const createMainOccupationApi = async (payload: TCreateMainOccupationReqDto): Promise<TCreateMainOccupationResDto> => {
  const rs = await globalApi.post<TCreateMainOccupationResDto>("/master/main-occupations", payload);
  return rs.data;
};

export const updateMainOccupationApi = async (payload: TUpdateMainOccupationReqDto): Promise<TUpdateMainOccupationResDto> => {
  const rs = await globalApi.put<TUpdateMainOccupationResDto>("/master/main-occupations", payload);
  return rs.data;
};

export const setHiddenMainOccupationApi = async (mainOccupationId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/main-occupations/${mainOccupationId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMainOccupationList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_MAIN_OCCUPATION],
    queryFn: () => fetchMainOccupationListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//specific-activity-occupation
export const fetchSpecificActivityOccupationListApi = async (): Promise<TGetSpecificActivityOccupationListResDto> => {
  const rs = await globalApi.get<TGetSpecificActivityOccupationListResDto>("/master/specific-activity-occupations");
  return rs.data;
};

export const createSpecificActivityOccupationApi = async (
  payload: TCreateSpecificActivityOccupationReqDto,
): Promise<TCreateSpecificActivityOccupationResDto> => {
  const rs = await globalApi.post<TCreateSpecificActivityOccupationResDto>("/master/specific-activity-occupations", payload);
  return rs.data;
};

export const updateSpecificActivityOccupationApi = async (
  payload: TUpdateSpecificActivityOccupationReqDto,
): Promise<TUpdateSpecificActivityOccupationResDto> => {
  const rs = await globalApi.put<TUpdateSpecificActivityOccupationResDto>("/master/specific-activity-occupations", payload);
  return rs.data;
};

export const setHiddenSpecificActivityOccupationApi = async (
  specificActivityOccupationId: number,
  payload: { isHidden: boolean },
): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/specific-activity-occupations/${specificActivityOccupationId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSpecificActivityOccupationList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SPECIFIC_ACTIVITY_OCCUPATION],
    queryFn: () => fetchSpecificActivityOccupationListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//main-industry
export const fetchMainIndustryListApi = async (): Promise<TGetMainIndustryListResDto> => {
  const rs = await globalApi.get<TGetMainIndustryListResDto>("/master/main-industries");
  return rs.data;
};

export const createMainIndustryApi = async (payload: TCreateMainIndustryReqDto): Promise<TCreateMainIndustryResDto> => {
  const rs = await globalApi.post<TCreateMainIndustryResDto>("/master/main-industries", payload);
  return rs.data;
};

export const updateMainIndustryApi = async (payload: TUpdateMainIndustryReqDto): Promise<TUpdateMainIndustryResDto> => {
  const rs = await globalApi.put<TUpdateMainIndustryResDto>("/master/main-industries", payload);
  return rs.data;
};

export const setHiddenMainIndustryApi = async (mainIndustryId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/main-industries/${mainIndustryId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMainIndustryList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_MAIN_INDUSTRY],
    queryFn: () => fetchMainIndustryListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//local-government-counter
export const fetchLocalGovernmentCounterListApi = async (): Promise<TGetLocalGovernmentCounterListResDto> => {
  const rs = await globalApi.get<TGetLocalGovernmentCounterListResDto>("/master/local-government-counters");
  return rs.data;
};

export const createLocalGovernmentCounterApi = async (payload: TCreateLocalGovernmentCounterReqDto): Promise<TCreateLocalGovernmentCounterResDto> => {
  const rs = await globalApi.post<TCreateLocalGovernmentCounterResDto>("/master/local-government-counters", payload);
  return rs.data;
};

export const updateLocalGovernmentCounterApi = async (payload: TUpdateLocalGovernmentCounterReqDto): Promise<TUpdateLocalGovernmentCounterResDto> => {
  const rs = await globalApi.put<TUpdateLocalGovernmentCounterResDto>("/master/local-government-counters", payload);
  return rs.data;
};

export const setHiddenLocalGovernmentCounterApi = async (localGovernmentCounterId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/local-government-counters/${localGovernmentCounterId}/set-hidden`, payload);
  return rs.data;
};

export const useGetLocalGovernmentCounterList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_LOCAL_GOVERNMENT_COUNTER],
    queryFn: () => fetchLocalGovernmentCounterListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//language-test
export const fetchLanguageTestListApi = async (): Promise<TGetLanguageTestListResDto> => {
  const rs = await globalApi.get<TGetLanguageTestListResDto>("/master/language-tests");
  return rs.data;
};

export const createLanguageTestApi = async (payload: TCreateLanguageTestReqDto): Promise<TCreateLanguageTestResDto> => {
  const rs = await globalApi.post<TCreateLanguageTestResDto>("/master/language-tests", payload);
  return rs.data;
};

export const updateLanguageTestApi = async (payload: TUpdateLanguageTestReqDto): Promise<TUpdateLanguageTestResDto> => {
  const rs = await globalApi.put<TUpdateLanguageTestResDto>("/master/language-tests", payload);
  return rs.data;
};

export const setHiddenLanguageTestApi = async (languageTestId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/language-tests/${languageTestId}/set-hidden`, payload);
  return rs.data;
};

export const syncLanguageTestLevelsApi = async (
  languageTestId: number,
  payload: TSyncLanguageTestLevelsReqDto,
): Promise<TSyncLanguageTestLevelsResDto> => {
  const rs = await globalApi.put<TSyncLanguageTestLevelsResDto>(`/master/language-tests/${languageTestId}/levels`, payload);
  return rs.data;
};

export const checkLanguageTestLevelInUseApi = async (languageTestId: number, levelId: number): Promise<TCheckLanguageTestLevelInUseResDto> => {
  const rs = await globalApi.get<TCheckLanguageTestLevelInUseResDto>(`/master/language-tests/${languageTestId}/levels/${levelId}/check-in-use`);
  return rs.data;
};

export const useGetLanguageTestList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_LANGUAGE_TEST],
    queryFn: () => fetchLanguageTestListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//career-certification
export const fetchCareerCertificationListApi = async (): Promise<TGetCareerCertificationListResDto> => {
  const rs = await globalApi.get<TGetCareerCertificationListResDto>("/master/career-certifications");
  return rs.data;
};

export const createCareerCertificationApi = async (payload: TCreateCareerCertificationReqDto): Promise<TCreateCareerCertificationResDto> => {
  const rs = await globalApi.post<TCreateCareerCertificationResDto>("/master/career-certifications", payload);
  return rs.data;
};

export const updateCareerCertificationApi = async (payload: TUpdateCareerCertificationReqDto): Promise<TUpdateCareerCertificationResDto> => {
  const rs = await globalApi.put<TUpdateCareerCertificationResDto>("/master/career-certifications", payload);
  return rs.data;
};

export const setHiddenCareerCertificationApi = async (careerCertificationId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/career-certifications/${careerCertificationId}/set-hidden`, payload);
  return rs.data;
};

export const useGetCareerCertificationList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_CAREER_CERTIFICATION],
    queryFn: () => fetchCareerCertificationListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//skill-test
export const fetchSkillTestListApi = async (): Promise<TGetSkillTestListResDto> => {
  const rs = await globalApi.get<TGetSkillTestListResDto>("/master/skill-tests");
  return rs.data;
};

export const createSkillTestApi = async (payload: TCreateSkillTestReqDto): Promise<TCreateSkillTestResDto> => {
  const rs = await globalApi.post<TCreateSkillTestResDto>("/master/skill-tests", payload);
  return rs.data;
};

export const updateSkillTestApi = async (payload: TUpdateSkillTestReqDto): Promise<TUpdateSkillTestResDto> => {
  const rs = await globalApi.put<TUpdateSkillTestResDto>("/master/skill-tests", payload);
  return rs.data;
};

export const setHiddenSkillTestApi = async (skillTestId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/skill-tests/${skillTestId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSkillTestList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SKILL_TEST],
    queryFn: () => fetchSkillTestListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

//company-specific-industry
const COMPANY_SPECIFIC_INDUSTRIES_URL = "/master/company-specific-industries";

export const fetchCompanySpecificIndustryListApi = async (): Promise<TGetCompanySpecificIndustryListResDto> => {
  const rs = await globalApi.get<TGetCompanySpecificIndustryListResDto>(COMPANY_SPECIFIC_INDUSTRIES_URL);
  return rs.data;
};

export const createCompanySpecificIndustryApi = async (
  payload: TCreateCompanySpecificIndustryReqDto,
): Promise<TCreateCompanySpecificIndustryResDto> => {
  const rs = await globalApi.post<TCreateCompanySpecificIndustryResDto>(COMPANY_SPECIFIC_INDUSTRIES_URL, payload);
  return rs.data;
};

export const createCompanySpecificBusinessClassificationApi = async (
  payload: TCreateCompanySpecificBusinessClassificationReqDto,
): Promise<TCreateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.post<TCreateCompanySpecificBusinessClassificationResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${payload.companySpecificIndustryId}/company-specific-business-classifications`,
    payload,
  );
  return rs.data;
};

export const updateCompanySpecificBusinessClassificationApi = async (
  companySpecificBusinessClassificationId: number,
  payload: TUpdateCompanySpecificBusinessClassificationReqDto,
): Promise<TUpdateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificBusinessClassificationResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${payload.companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}`,
    payload,
  );
  return rs.data;
};
export const setHiddenCompanySpecificBusinessClassificationApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificBusinessClassificationResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const updateCompanySpecificIndustryApi = async (
  payload: TUpdateCompanySpecificIndustryReqDto,
): Promise<TUpdateCompanySpecificIndustryResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificIndustryResDto>(COMPANY_SPECIFIC_INDUSTRIES_URL, payload);
  return rs.data;
};

export const setHiddenCompanySpecificIndustryApi = async (companySpecificIndustryId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/set-hidden`, payload);
  return rs.data;
};

export const setEmploymentTrainingCompanyMainSkillApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  mainSkillId: number,
  payload: { isEmploymentTraining: boolean },
): Promise<TUpdateCompanyMainSkillResDto> => {
  const rs = await globalApi.put<TUpdateCompanyMainSkillResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/main-skills/${mainSkillId}/set-employment-training`,
    payload,
  );
  return rs.data;
};

export const setSpecificSkillCompanySpecificBusinessClassificationApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  payload: { isSpecificSkill: boolean },
): Promise<TUpdateCompanySpecificBusinessClassificationResDto> => {
  const rs = await globalApi.put<TUpdateCompanySpecificBusinessClassificationResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/set-specific-skill`,
    payload,
  );
  return rs.data;
};

export const createCompanyMainSkillApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  payload: TCreateCompanyMainSkillReqDto,
): Promise<TCreateCompanyMainSkillResDto> => {
  const rs = await globalApi.post<TCreateCompanyMainSkillResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/main-skills`,
    payload,
  );
  return rs.data;
};

export const updateCompanyMainSkillApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  mainSkillId: number,
  payload: TUpdateCompanyMainSkillReqDto,
): Promise<TUpdateCompanyMainSkillResDto> => {
  const rs = await globalApi.put<TUpdateCompanyMainSkillResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/main-skills/${mainSkillId}`,
    payload,
  );
  return rs.data;
};

export const setHiddenCompanyMainSkillApi = async (
  companySpecificIndustryId: number,
  companySpecificBusinessClassificationId: number,
  mainSkillId: number,
  payload: { isHidden: boolean },
): Promise<TUpdateCompanyMainSkillResDto> => {
  const rs = await globalApi.put<TUpdateCompanyMainSkillResDto>(
    `${COMPANY_SPECIFIC_INDUSTRIES_URL}/${companySpecificIndustryId}/company-specific-business-classifications/${companySpecificBusinessClassificationId}/main-skills/${mainSkillId}/set-hidden`,
    payload,
  );
  return rs.data;
};

export const useGetCompanySpecificIndustryList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_COMPANY_SPECIFIC_INDUSTRY],
    queryFn: () => fetchCompanySpecificIndustryListApi(),
  });

  const companySpecificIndustryOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: item.companySpecificIndustry, value: toNumber(item.id), hidden: item.isHidden })) : []),
    [data],
  );

  const getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry = useCallback(
    (companySpecificIndustryId: number | string) => {
      const foundCompanySpecificIndustry = data ? data.data.find((item) => toNumber(item.id) === toNumber(companySpecificIndustryId)) : undefined;
      if (!foundCompanySpecificIndustry) return [];
      const options =
        foundCompanySpecificIndustry?.companySpecificBusinessClassifications?.map((item) => ({
          label: item.companySpecificBusinessClassificationName,
          value: item.id,
          hidden: item.isHidden,
        })) || [];
      return options;
    },
    [data],
  );

  return {
    data: data?.data ?? [],
    companySpecificIndustryOptions,
    getCompanySpecificBusinessClassificationListOptionByCompanySpecificIndustry,
    ...rest,
  };
};

//support-language
export const fetchSupportLanguageListApi = async (): Promise<TGetSupportLanguageListResDto> => {
  const rs = await globalApi.get<TGetSupportLanguageListResDto>("/master/support-languages");
  return rs.data;
};

export const createSupportLanguageApi = async (payload: TCreateSupportLanguageReqDto): Promise<TCreateSupportLanguageResDto> => {
  const rs = await globalApi.post<TCreateSupportLanguageResDto>("/master/support-languages", payload);
  return rs.data;
};

export const updateSupportLanguageApi = async (payload: TUpdateSupportLanguageReqDto): Promise<TUpdateSupportLanguageResDto> => {
  const rs = await globalApi.put<TUpdateSupportLanguageResDto>("/master/support-languages", payload);
  return rs.data;
};

export const setHiddenSupportLanguageApi = async (supportLanguageId: number, payload: { isHidden: boolean }): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`/master/support-languages/${supportLanguageId}/set-hidden`, payload);
  return rs.data;
};

export const useGetSupportLanguageList = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_SUPPORT_LANGUAGE],
    queryFn: () => fetchSupportLanguageListApi(),
  });

  return { data: data?.data ?? [], ...rest };
};

const STANDARD_INDUSTRY_API_URL = {
  GROUPS: "/master/standard-industry-groups",
  CLASSIFICATIONS: "/master/standard-industry-classifications",
} as const;

export const fetchStandardIndustryGroupListApi = async (
  params?: TGetStandardIndustryGroupListReqDto,
): Promise<TGetStandardIndustryGroupListResDto> => {
  const rs = await globalApi.get<TGetStandardIndustryGroupListResDto>(STANDARD_INDUSTRY_API_URL.GROUPS, { params });
  return rs.data;
};

export const fetchStandardIndustryClassificationListApi = async (
  params: TGetStandardIndustryClassificationListReqDto,
): Promise<TGetStandardIndustryClassificationListResDto> => {
  const rs = await globalApi.get<TGetStandardIndustryClassificationListResDto>(STANDARD_INDUSTRY_API_URL.CLASSIFICATIONS, { params });
  return rs.data;
};

export const fetchStandardIndustryClassificationApi = async (id: number): Promise<TGetStandardIndustryClassificationResDto> => {
  const rs = await globalApi.get<TGetStandardIndustryClassificationResDto>(`${STANDARD_INDUSTRY_API_URL.CLASSIFICATIONS}/${id}`);
  return rs.data;
};

export const createStandardIndustryGroupApi = async (payload: TCreateStandardIndustryGroupReqDto): Promise<TCreateStandardIndustryGroupResDto> => {
  const rs = await globalApi.post<TCreateStandardIndustryGroupResDto>(STANDARD_INDUSTRY_API_URL.GROUPS, payload);
  return rs.data;
};

export const updateStandardIndustryGroupApi = async (
  id: number,
  payload: TUpdateStandardIndustryGroupReqDto,
): Promise<TUpdateStandardIndustryGroupResDto> => {
  const rs = await globalApi.put<TUpdateStandardIndustryGroupResDto>(`${STANDARD_INDUSTRY_API_URL.GROUPS}/${id}`, payload);
  return rs.data;
};

export const createStandardIndustryClassificationApi = async (
  payload: TCreateStandardIndustryClassificationReqDto,
): Promise<TCreateStandardIndustryClassificationResDto> => {
  const rs = await globalApi.post<TCreateStandardIndustryClassificationResDto>(STANDARD_INDUSTRY_API_URL.CLASSIFICATIONS, payload);
  return rs.data;
};

export const updateStandardIndustryClassificationApi = async (
  id: number,
  payload: TUpdateStandardIndustryClassificationReqDto,
): Promise<TUpdateStandardIndustryClassificationResDto> => {
  const rs = await globalApi.put<TUpdateStandardIndustryClassificationResDto>(`${STANDARD_INDUSTRY_API_URL.CLASSIFICATIONS}/${id}`, payload);
  return rs.data;
};

export const setHiddenStandardIndustryClassificationApi = async (
  id: number,
  payload: TSetHiddenStandardIndustryClassificationReqDto,
): Promise<boolean> => {
  const rs = await globalApi.put<boolean>(`${STANDARD_INDUSTRY_API_URL.CLASSIFICATIONS}/${id}/set-hidden`, payload);
  return rs.data;
};

// --- queries ---
export const useGetStandardIndustryGroupList = (params?: TGetStandardIndustryGroupListReqDto) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_GROUP, params],
    queryFn: () => fetchStandardIndustryGroupListApi(params),
  });

  return { data: data?.data ?? [], pagination: data?.pagination, ...rest };
};

export const useGetStandardIndustryClassificationList = (params: TGetStandardIndustryClassificationListReqDto) => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_CLASSIFICATION, params],
    queryFn: () => fetchStandardIndustryClassificationListApi(params),
    enabled: Boolean(params.groupId || params.parentId),
  });

  return { data: data?.data ?? [], pagination: data?.pagination, ...rest };
};

// --- mutations ---
export const useCreateStandardIndustryGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: TCreateStandardIndustryGroupReqDto) => createStandardIndustryGroupApi(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_GROUP] }),
  });
};

export const useUpdateStandardIndustryGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TUpdateStandardIndustryGroupReqDto }) => updateStandardIndustryGroupApi(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_GROUP] }),
  });
};

export const useCreateStandardIndustryClassification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: TCreateStandardIndustryClassificationReqDto) => createStandardIndustryClassificationApi(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_CLASSIFICATION] }),
  });
};

export const useUpdateStandardIndustryClassification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TUpdateStandardIndustryClassificationReqDto }) =>
      updateStandardIndustryClassificationApi(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_CLASSIFICATION] }),
  });
};

export const useSetHiddenStandardIndustryClassification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TSetHiddenStandardIndustryClassificationReqDto }) =>
      setHiddenStandardIndustryClassificationApi(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_STANDARD_INDUSTRY_CLASSIFICATION] }),
  });
};

// ---------- Master Occupations (技能実習の職種・作業・試験名) ----------
const MASTER_OCCUPATIONS_URL = "/master/occupations";

export const fetchMasterOccupationTreeApi = async (): Promise<TGetMasterOccupationTreeResDto> => {
  const rs = await globalApi.get<TGetMasterOccupationTreeResDto>(`${MASTER_OCCUPATIONS_URL}/tree`);
  return rs.data;
};

export const createMasterOccupationApi = async (payload: TCreateMasterOccupationReqDto): Promise<TCreateMasterOccupationResDto> => {
  const rs = await globalApi.post<TCreateMasterOccupationResDto>(MASTER_OCCUPATIONS_URL, payload);
  return rs.data;
};

export const updateMasterOccupationApi = async (
  occupationId: number,
  payload: TUpdateMasterOccupationReqDto,
): Promise<TUpdateMasterOccupationResDto> => {
  const rs = await globalApi.put<TUpdateMasterOccupationResDto>(`${MASTER_OCCUPATIONS_URL}/${occupationId}`, payload);
  return rs.data;
};

export const reorderMasterOccupationsApi = async (payload: TReorderMasterOccupationsReqDto): Promise<TReorderMasterOccupationsResDto> => {
  const rs = await globalApi.put<TReorderMasterOccupationsResDto>(MASTER_OCCUPATIONS_URL, payload);
  return rs.data;
};

export const setHiddenMasterOccupationApi = async (
  occupationId: number,
  payload: TSetHiddenMasterOccupationReqDto,
): Promise<TSetHiddenMasterOccupationResDto> => {
  const rs = await globalApi.put<TSetHiddenMasterOccupationResDto>(`${MASTER_OCCUPATIONS_URL}/${occupationId}/set-hidden`, payload);
  return rs.data;
};

export const useGetMasterOccupationTree = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.MASTER_OCCUPATION],
    queryFn: () => fetchMasterOccupationTreeApi(),
  });

  return {
    data: data?.data ?? [],
    ...rest,
  };
};

// --- mutations ---
// 作成・更新・並び替え・表示切替はいずれも id しか返さないため、成功時はツリーを取り直す。
export const useCreateMasterOccupation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: TCreateMasterOccupationReqDto) => createMasterOccupationApi(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_OCCUPATION] }),
  });
};

export const useUpdateMasterOccupation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TUpdateMasterOccupationReqDto }) => updateMasterOccupationApi(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_OCCUPATION] }),
  });
};

export const useReorderMasterOccupations = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: TReorderMasterOccupationsReqDto) => reorderMasterOccupationsApi(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_OCCUPATION] }),
  });
};

export const useSetHiddenMasterOccupation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: TSetHiddenMasterOccupationReqDto }) => setHiddenMasterOccupationApi(id, payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_OCCUPATION] }),
  });
};
